import { render, staticRenderFns } from "./ProductActionDelete.vue?vue&type=template&id=1a8f8d34&"
import script from "./ProductActionDelete.vue?vue&type=script&lang=ts&"
export * from "./ProductActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports